<template>
  <div v-if="position">
    <span><b>{{ position.entityName }}:</b>&nbsp;</span>
    <span><i><template v-if="position.dateTo==null">Depuis </template>[{{ position.dateFrom }}]<template v-if="position.dateTo"> - [{{ position.dateTo }}]</template></i></span>
  </div>
</template>

<script>
export default {
  props: {
    position: {
      type: Object,
      default: () => null
    }
  }
}
</script>
